import {RootState} from '@/store'
import {Module} from 'vuex'
import {FilterState} from '../types'
import {vuexStorageMutations} from '../utils'

export interface SessionState extends FilterState {

}

const module: Module<SessionState, RootState> = {
  namespaced: true,
  state: {
    except: ['auth.firstAuth'],
    only: [
      'auth',
      'payment',
      'issue.previewData',
      'invoices.issued.invoiceDocumentData',
      'invoices.issued.invoice',
      'invoices.external',
    ],
  },
  mutations: {
    ...vuexStorageMutations,
  },
}

export default module
